"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverStyleSheets = exports.generateClassName = void 0;
var _styles = require("@material-ui/styles");
var createGenerateClassNameHash = require('@material-ui/styles/createGenerateClassName/createGenerateClassNameHash').default;
var generateClassName = exports.generateClassName = createGenerateClassNameHash({
  productionPrefix: 'lvtr'
});
var serverStyleSheets = exports.serverStyleSheets = new _styles.ServerStyleSheets({
  serverGenerateClassName: generateClassName
});